export default __webpack_public_path__ + "images/HHI.686518a.png";